module.exports = __webpack_public_path__ + "8ac3b662d5d1245cc8abf4ed6018c1ec.pdf";